import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, Navigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useAuth } from '../AuthContext';
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../Firebase/FirebaseConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Login() {

    const baseURL = process.env.REACT_APP_BASE_URL;
    const [isUsernameValid, setIsUsernameValid] = useState(true);
    const [isPasswordValid, setIsPasswordValid] = useState(true);
    const { login } = useAuth();
    const { isAuthenticated } = useAuth();
    const [isLoginLoading, setIsLoginLoading] = useState(false);
    const [isForgotLoading, setIsForgotLoading] = useState(false);

    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const [captcha, setCaptcha] = useState(generateCaptcha());
    const [captchaInput, setCaptchaInput] = useState('');
    const [isCaptchaValid, setIsCaptchaValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageForgot, setErrorMessageForgot] = useState('');
    const [forgotPasswordSuccessMessage, setForgotPasswordSuccessMessage] = useState('');
    const [timer, setTimer] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (timer > 0) {
            const countdown = setTimeout(() => setTimer(timer - 1), 1000);
            return () => clearTimeout(countdown);
        }
    }, [timer]);

    useEffect(() => {
        if (errorMessage) {
            const timer = setTimeout(() => setErrorMessage(''), 10000);
            return () => clearTimeout(timer);
        }
    }, [errorMessage]);

    useEffect(() => {
        if (errorMessageForgot) {
            const timer = setTimeout(() => setErrorMessageForgot(''), 10000);
            return () => clearTimeout(timer);
        }
    }, [errorMessageForgot]);

    /* useEffect(() => {
        if (forgotPasswordSuccessMessage) {
            const timer = setTimeout(() => setForgotPasswordSuccessMessage(''), 10000);
            return () => clearTimeout(timer);
        }
    }, [forgotPasswordSuccessMessage]); */


    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);

        setFormData({
            ...formData,
            [name]: sanitizedValue,
        });

        if (name === 'email') setIsUsernameValid(sanitizedValue.length >= 5);
        if (name === 'password') setIsPasswordValid(sanitizedValue.length >= 8);
    };

    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    function generateCaptcha() {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    }

    const handleCaptchaChange = (e) => {
        setCaptchaInput(DOMPurify.sanitize(e.target.value));
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        console.log('Login attempt with:', formData);


        if (!isUsernameValid) {
            toast.error('Username should be at least 5 characters long.');
            return;
        }
        if (!isPasswordValid) {
            toast.error('Password should be at least 8 characters long.');
            return;
        }
        if (captchaInput !== captcha) {
            toast.error('Incorrect CAPTCHA. Please try again.');
            setIsCaptchaValid(false);
            setCaptcha(generateCaptcha());
            setCaptchaInput('');
            return;
        }

        setIsLoginLoading(true);

        try {
            const response = await fetch(`${baseURL}/login`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                    password: formData.password,
                    user_source: "Web",
                    version: "1.0.0"
                }),
            });

            const result = await response.json();
            console.log('Response body:', result);

            if (response.ok) {

                if (result.status_code === 200) {
                    const { access_token, refresh_token, user } = result;

                    // Store tokens and user ID in localStorage
                    localStorage.setItem('authToken', access_token);
                    localStorage.setItem('refreshToken', refresh_token);
                    localStorage.setItem('userid', user[0].userid);
                    login();
                    console.log("Gmail:", user[0].email);
                    /*  if (user[0].email === null) {
                         window.location.href = "/profile";
                     }
                     else {
                         window.location.href = "/home";
                     } */

                    /* if (user[0].email === "") {
                        navigate("/profile");
                    } else {
                        navigate("/home");
                    } */
                    if (user[0].is_profile_completed === true) {
                        navigate("/home");
                    } else {
                        navigate("/edit_detail");
                    }

                }
                else {
                    toast.error(result.message || 'Login Failed'); // Set error message from response
                    setCaptcha(generateCaptcha());  // Reset CAPTCHA on error
                    setCaptchaInput('');
                }

            } else {
                toast.error(result.message || 'Login Failed'); // Set error message from response
                setCaptcha(generateCaptcha());  // Reset CAPTCHA on error
                setCaptchaInput('');
            }
        } catch (error) {
            toast.error('An error occurred. Please try again.');
            setCaptcha(generateCaptcha());  // Reset CAPTCHA on error
            setCaptchaInput('');
        }
        finally {
            setIsLoginLoading(false);
        }
    };


    const handleForgot = async (e) => {
        e.preventDefault();
        setIsForgotLoading(true);
        setForgotPasswordSuccessMessage('');
        console.log('Forgot attempt with:', formData);




        try {
            const response = await fetch(`${baseURL}/password-reset-request`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                }),
            });

            const result = await response.json();

            if (response.ok) {

                setForgotPasswordSuccessMessage('Password Send Sucessfuly If you not getting any mail try after few seconds');
                const { token } = result;

                // Store tokens and user ID in localStorage
                localStorage.setItem('authToken', token);
                toast.success(result.message || 'Request Sucess');
                setTimer(60);
            } else {
                toast.error(result.message || 'Request Failed'); // Set error message from response

            }
        } catch (error) {
            setErrorMessageForgot('An error occurred. Please try again.');
        }
        finally {
            setIsForgotLoading(false);
        }


    };

    /* const handleGoogle = async () => {
        try {
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);
            if (result.user) {
                account_type: 1,
                // Optional: Store additional information if needed
                login(); // Call your login function to handle any app-specific logic
                window.location.href = "/home";
                console.log(result)
            }
        } catch (error) {
            setErrorMessage('An error occurred during Google sign-in. Please try again.');
            console.error(error);
        }
    }; */


    const handleGoogle = async () => {
        try {
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);

            if (result.user) {
                const idToken = await result.user.getIdToken(); // Get Firebase ID token
                const userData = {
                    account_type: 1,
                    email: result.user.email,
                };


                // Send user data to the backend for validation/registration
                const response = await fetch(`${baseURL}/google-social-login`, {
                    method: 'POST',
                    headers: {
                        'accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        ...userData,
                        idToken, // Send Firebase ID token for server-side validation
                    }),
                });

                const resultData = await response.json();
                // console.log("Response body:", resultData);

                if (response.ok) {
                    const { access_token, refresh_token, user } = resultData;

                    // Store tokens and user data in localStorage
                    localStorage.setItem('authToken', access_token);
                    localStorage.setItem('refreshToken', refresh_token);
                    localStorage.setItem('userid', user[0].userid);
                    
                    console.log("Login:", user[0].login);
                    // Redirect based on is_profile_completed
                    if (user[0].login === true) {
                        login(); // Call your app-specific login function
                        navigate("/home");
                    } else {
                        navigate("/edit_detail", {
                            state: { email: result.user.email, accountType: 1 } // Send email in location state
                        });
                    }
                } else {
                    toast.error(resultData.detail || 'Google login failed');
                }
            }
        } catch (error) {
            toast.error('An error occurred during Google sign-in. Please try again.');
            console.error(error);
        }
    };

    if (isAuthenticated) {
        // Redirect to the home page or another authenticated route
        return <Navigate to="/" />;
    }





    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                theme="dark"
            />

            <section className='user-form-part'>
                <div className='container'>
                    <div className='row justify-content-center align-items-center'>
                        <div className='col-xl-8 col-md-12 main-user-box'>
                            <div className='row justify-content-center align-items-strech row-flex'>
                                <div className='col-md-8 text-center px-0 d-flex justify-content-center align-items-center'>
                                    <form onSubmit={handleLogin}>
                                        <div className="col-md-12">
                                            <h4 className='user-title mt-5 mb-3 text-center'>Login to NDL</h4>
                                            <div className="form-group">
                                                <input type="email" className="form-control" name="email" onChange={handleChange} placeholder='Email' required autoComplete="current-password" />
                                            </div>
                                            <div className="form-group">
                                                <input type={showPassword ? 'text' : 'password'} id="password" name="password" className="form-control" onChange={handleChange} placeholder='Password' required autoComplete="current-password" />
                                                <span toggle="#password" className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`} onClick={togglePasswordVisibility}></span>
                                            </div>
                                            <div className="form-group capcha-text mb-2">
                                                <label className=''><strong>{captcha}</strong></label>
                                                <input type="text" className="form-control" value={captchaInput} onChange={handleCaptchaChange} placeholder="Enter CAPTCHA here" required />

                                            </div>
                                            {!isCaptchaValid && <small style={{ color: 'red' }}>Incorrect CAPTCHA, please try again.</small>}
                                            {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                            <div className='forgot-password'>
                                                <NavLink data-bs-toggle="modal" data-bs-target="#forgot-password">Forgot Password?</NavLink>

                                            </div>
                                            <div className="col-md-12 text-center">
                                                <button type="submit" className='btn-6 view-all-btnn mb-3 mt-2 text-capitalize px-5' disabled={isLoginLoading}>
                                                    {isLoginLoading ? <div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div> : 'Sign In'}
                                                </button>
                                            </div>
                                            <div class="user-form-divider">
                                                <p>or</p>
                                            </div>
                                            <div className="col-md-12 text-center user-form-social mb-2 mt-4">
                                                <button type='button' className='social-login' onClick={() => handleGoogle()}>
                                                    Sign in with Google</button>
                                            </div>
                                        </div>

                                        <h5 className='already_account_title pb-4'>Don't have any account? <NavLink to="/sendotp">Create a new account</NavLink></h5>
                                    </form>
                                </div>
                                <div className='col-md-4 d-flex px-0'>
                                    <div className='user-box'>
                                        <img src="assets/images/elements/vidhya_login_icon.png" className='vidhya_icon vidhya_login_icon' alt="Section-Image" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="user-form-part d-none">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-5">
                            <div className="user-form-card">
                                <div className="user-form-title">
                                    <h2>Welcome</h2>
                                    <p>Enter your credentials to access your account</p>
                                </div>
                                {/*  <div>
                                    <h1>Welcome to the App</h1>

                                </div> */}
                                <div className="user-form-group">
                                    <form onSubmit={handleLogin} className="user-form">
                                        <div className="form-group">
                                            <input type="email" className="form-control" name="email" onChange={handleChange} placeholder='Enter email' required autoComplete="current-password" />
                                        </div>
                                        <div className="form-group mb-2">
                                            <input type={showPassword ? 'text' : 'password'} id="password" name="password" className="form-control" onChange={handleChange} placeholder='Enter Password' required autoComplete="current-password" />
                                            <span toggle="#password" className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`} onClick={togglePasswordVisibility}></span>
                                        </div>
                                        <div className="form-group capcha-text">
                                            <label className=''><strong>{captcha}</strong></label>
                                            <input type="text" className="form-control" value={captchaInput} onChange={handleCaptchaChange} placeholder="Enter CAPTCHA here" required />

                                        </div>
                                        {!isCaptchaValid && <small style={{ color: 'red' }}>Incorrect CAPTCHA, please try again.</small>}
                                        {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                        <div className='forgot-password'>
                                            <NavLink data-bs-toggle="modal" data-bs-target="#forgot-password">Forgot Password?</NavLink>

                                        </div>
                                        <div className="col-md-12 text-center">
                                            <button type="submit" className='btn-6 view-all-btnn mt-3 px-5 text-capitalize' disabled={isLoginLoading}>
                                                {isLoginLoading ? <div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div> : 'Sign In'}
                                            </button>
                                        </div>
                                        <div class="user-form-divider">
                                            <p>or</p>
                                        </div>
                                        <div className="col-md-12 text-center user-form-social">
                                            <button type='button' className='social-login' onClick={() => handleGoogle()}>
                                                Sign in with Google</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="user-form-remind">
                                <p>Don't have any account? <NavLink to="/sendotp">Create a new account</NavLink></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            

            <div class="modal fade set-md-width" id="forgot-password" tabindex="-1" aria-labelledby="forgot-password" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <button class="modal-close icofont-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="modal-body">
                                <div className='row justify-content-center'>
                                    <div className='col-md-10'>

                                        <div className="user-form-title">
                                            <h2>Forgot Password</h2>
                                        </div>
                                        <div className="user-form-group">
                                            <form onSubmit={handleForgot} className="user-form">
                                                <div className="form-group">
                                                    <input type="email" className="form-control" name="email" onChange={handleChange} placeholder='Enter email' required autoComplete="current-password" />
                                                </div>

                                                <div className="col-md-12 text-center">
                                                    {errorMessageForgot && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessageForgot}</div>}
                                                    {forgotPasswordSuccessMessage && <div style={{ color: 'green', marginTop: '10px' }}>{forgotPasswordSuccessMessage}</div>}
                                                    <button
                                                        type="submit"
                                                        className={`btn-6 view-all-btnn mt-3 text-capitalize ${isForgotLoading || timer > 0 ? 'disabled' : ''}`}
                                                        disabled={isForgotLoading || timer > 0}
                                                    >
                                                        {isForgotLoading ? <div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div> : (timer > 0 ? `Try again in ${timer}s` : 'Send')}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    );
}
